<template>
  <FeedbackStep :title="title" :number="number">
    <template v-slot:content>
      <div class="feedback-form">
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            id="q5AnswerYes"
            type="radio"
            name="q5Answer"
            value="tak"
            v-model.trim="form.answer_q5"
            @input="delayTouch($v.form.answer_q5)"
            @click="hasDescription = false"
          />
          <label for="q5AnswerYes" class="form__label">tak</label>
        </div>
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            id="q5AnswerNo"
            type="radio"
            name="q5Answer"
            value="nie"
            v-model.trim="form.answer_q5"
            @input="delayTouch($v.form.answer_q5)"
            @click="hasDescription = false"
          />
          <label for="q5AnswerNo" class="form__label">nie</label>
        </div>
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            id="q5AnswerOther"
            type="radio"
            name="q5Answer"
            value="inna odpowiedź"
            v-model.trim="form.answer_q5"
            @input="delayTouch($v.form.answer_q5)"
            @change="otherHandler"
          />
          <label for="q5AnswerOther" class="form__label">inna odpowiedź</label>
        </div>
        <transition name="fade-input">
          <div
            v-if="hasDescription"
            class="form__input-wrapper"
            :class="{ error: $v.form.answer_q5_content.$anyError }"
          >
            <label for="answer_q5_content" class="form__label uk-hidden"
              >Podaj inne</label
            >
            <input
              class="form-input uk-width-1-1"
              id="answer_q5_content"
              type="text"
              name="answer_q5_content"
              ref="otherInput"
              @input="event => delayTouchCounterComposition(
                $v.form,
                'answer_q5_content',
                event.target.value
              )"
            />
            <span class="form__error-message form__error-message--no-label">
              <template v-if="!$v.form.answer_q5_content.minLength">
                {{ validationMessage.minLength }}</template
              >
              <template v-if="!$v.form.answer_q5_content.required">
                {{ validationMessage.required }}</template
              >
            </span>
          </div>
        </transition>
      </div>
    </template>
  </FeedbackStep>
</template>
<script>
import { required, minLength } from 'vuelidate/lib/validators';
import stepValidation from '../../mixins/stepValidation';
import FeedbackStep from '../global/FeedbackStep.vue';

export default {
  name: 'Question5',
  components: { FeedbackStep },
  mixins: [stepValidation],
  data: () => ({
    title: 'Czy podczas realizowanej usługi każdy etap prac był jasny?'
    + 'Jeśli nie, prosimy o wskazanie, który etap współpracy wymagał doprecyzowania.',
    number: 5,
    form: {
      answer_q5: null,
      answer_q5_content: '',
    },
    hasDescription: false,
  }),
  validations() {
    if (!this.hasDescription) {
      return {
        form: {
          answer_q5: {
            required,
          },
        },
      };
    }
    return {
      form: {
        answer_q5: {
          required,
        },
        answer_q5_content: {
          required,
          minLength: minLength(3),
        },
      },
    };
  },
  methods: {
    otherHandler() {
      this.hasDescription = true;

      if (!this.hasDescription) {
        this.form.answer_q5_content = '';
      } else {
        setTimeout(() => {
          this.form.answer_q5_content = '';
          this.$refs.otherInput.focus();
        }, 100);
      }
    },
  },
};
</script>
